export default __webpack_public_path__ + "static/media/TIA.94f2c1e3.jpg";